import type { Variant } from '../gameTypes.js';
import type { PianoChart } from '../pianoChart.js';
import { PALETTE_VIOLET } from '../builtinPulseMaps/palettes.js';
import { buildBuiltinAudio } from '../builtinPulseMaps/audioFromOnsets.js';
import audioOnsets from '../circlesBuiltinMaps/audio/heroes.onsets.json' with { type: 'json' };
import { pianoVariantsFromSpec } from './pianoFromOnsets.js';

/**
 * Heroes Tonight — Janji feat. Johnning (NCS). 128 BPM progressive
 * house with a vocal-led melodic hook. Mid-tier difficulty bridges
 * the early tracks to the more demanding back half of the catalogue.
 *
 * Synthesised from the Circles onset analysis. See the header doc
 * on {@link import('./01-on-and-on.js').ON_AND_ON_PIANO_VARIANTS}
 * for the curated-MIDI upgrade path.
 */
export const HEROES_PIANO_VARIANTS: Record<Variant, PianoChart> = pianoVariantsFromSpec({
  baseSlug: 'heroes',
  baseTitle: 'Heroes Tonight',
  description:
    "Heroes Tonight by Janji feat. Johnning. Bouncy progressive house with a melodic vocal hook walking the lanes.",
  difficulty: 3,
  totalBeats: 131,
  palette: PALETTE_VIOLET,
  audio: buildBuiltinAudio({
    src: '/audio/circles/heroes.mp3',
    attribution:
      '"Heroes Tonight" by Janji (feat. Johnning) [NCS Release] - https://ncs.io/heroes-tonight',
    data: audioOnsets,
  }),
  onsets: audioOnsets,
  sections: [
    {
      startBeat: 0,
      endBeat: 131,
      selectOpts: { kinds: ['lead', 'snare'], minIntensity: 0.05, minSpacing: 0.5 },
    },
  ],
});
